// GENERATED by scripts/generate-changelog.js — do not edit by hand.
// Regenerated automatically before every build (npm prebuild hook).
const changelog = [
  {
    "version": "1.16.2",
    "date": "2026-10-26",
    "sections": [
      {
        "title": "Bug Fixes",
        "items": [
          "env: Fix env adjustemnt"
        ]
      }
    ]
  },
  {
    "version": "1.16.1",
    "date": "2026-10-16",
    "sections": [
      {
        "title": "Bug Fixes",
        "items": [
          "abdm: Fix abdm id verification",
          "abdm: Fix abdm verification"
        ]
      }
    ]
  },
  {
    "version": "1.16.0",
    "date": "2026-10-16",
    "sections": [
      {
        "title": "Features",
        "items": [
          "dental-prescription: improve odontogram UI and add paginated master dropdowns",
          "dental: enhance test and procedure masters with odontogram workflow integration",
          "external-lab: add admin registration and management UI",
          "external-lab: Add admin registration and management UI"
        ]
      },
      {
        "title": "Bug Fixes",
        "items": [
          "ConsentFieldsEditor: comment out Typography component for clarity",
          "docs: update comment formatting for release notes section in README",
          "doctor: Fix doctor list filters"
        ]
      }
    ]
  },
  {
    "version": "1.15.0",
    "date": "2026-10-13",
    "sections": [
      {
        "title": "Features",
        "items": [
          "consent: enhance consent document header and doctor details",
          "consent: enhance consent document header and doctor details",
          "dental: enhance procedure sessions and odontogram integration",
          "dental: enhance procedure sessions and odontogram integration"
        ]
      }
    ]
  },
  {
    "version": "1.14.0",
    "date": "2026-10-09",
    "sections": [
      {
        "title": "Features",
        "items": [
          "dental-workspace: complete clinical assessment and document wor…",
          "dental-workspace: complete clinical assessment and document workflows",
          "dental: enhance odontogram tooth findings and clinical evidence",
          "dental: enhance odontogram tooth findings and clinical evidence"
        ]
      },
      {
        "title": "Bug Fixes",
        "items": [
          "admin: Admin list pagination and filters"
        ]
      }
    ]
  }
];

export default changelog;
